import React, {Component} from 'react';
import {Link} from 'react-router-dom'

class districtFinancial extends Component {
    constructor(props) {
        super(props);

    };
  
    render() {
        const {school}=this.props;
        return (
                <div className="pricingTable">
                    <div className="priceUper">
                        <div className="priceTitle bg-color-1"><h3>Financial</h3></div>
                    </div>
                    <div className="row" style={styles.HeaderStyle}>
                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4" style={{textAlign: "left"}}>
                            <span>Site</span>

                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                            <span>Total Deposits</span>

                        </div>
                        <div className="col-lg-5 col-md-5 col-sm-5 col-xs-5">
                            <span>Ledger Balance(Current) </span>

                        </div>
                        
                    </div>
                    {
                        school.map(item=> (
                        <div className="row" style={styles.linkStyle} key={item.mealSchoolId}>
                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4" style={{textAlign:"left"}}>
                            <Link to={`/district/depositSummary`} onClick={()=>{
                                    this.props.setSelectedSchool(item.mealSchoolId)
                                }} role="button" aria-haspopup="true" aria-expanded="false"><i
                                         aria-hidden="true"/><span>{item.schoolName}</span></Link>

                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                 <span style={styles.linkStyle}>{(item.financial||{}).Deposit} </span>
                            </div>
                            <div className="col-lg-5 col-md-5 col-sm-5 col-xs-5">
                                <span>{(item.financial||{}).Balance}</span>

                            </div>
                            
                        </div>
                        ))
                    }
                    
                   
                </div>

        );
    }
}

const styles = {
    linkStyle: {
       
        textAlign : "center",
        marginLeft : 10,
        paddingBottom : 10,
        color:"rgb(120 120 121)"

    },
    HeaderStyle: {
        marginTop : 10,
        marginLeft:10,
        color: "red",
        marginBottom : 10,
        textAlign:"center"


    }
}

export default districtFinancial;




// WEBPACK FOOTER //
// ./src/components/District/Home/districtFinancial.jsx